import { faXmark } from '@fortawesome/free-solid-svg-icons';

import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CardButton } from '@shared/models';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    standalone: false,
})
export class CardComponent {
    @Input() public id: number = -1;
    @Input() public buttonList: CardButton[] = [];
    @Input() includeCloseButton = false;
    @Input() surfaceVariant: 'default' | 'strong' = 'default';

    @Output() public readonly clickedButton: EventEmitter<CardButton> = new EventEmitter();
    @Output() public readonly closeCard: EventEmitter<number> = new EventEmitter();

    public closeIcon = faXmark;

    constructor() {}

    buttonClicked(button: CardButton) {
        button.click?.(this.id);
        this.clickedButton.emit(button);
    }

    close() {
        this.closeCard.emit(this.id);
    }

    getModelId(index: number, _: CardButton) {
        return index;
    }
}
